<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li>
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li>
            <router-link to="/couponMaster">Coupons</router-link>
          </li>
          <li class="active"><a href="#">Coupon Generation</a></li>
        </ol>
        <div class="panel-body locationform">
          <div v-if="message" class="alert-danger alert visibility" role="alert">
            {{ message }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
          <form @submit.prevent="submitForm">
            <div class="row">
                  <legend>Generate Coupons:</legend>
                  
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Prefix coupon code</label>
                      <input
                        v-model="coupon.Prefix"
                        type="text"
                        placeholder="Prefix coupon code"
                        class="form-control"
                        name="Prefix"
                        @input="coupon.Prefix=$event.target.value.toUpperCase()"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Suffix coupon code</label>
                      <input
                        v-model="coupon.Suffix"
                        type="text"
                        placeholder="Suffix coupon code"
                        class="form-control"
                        name="Suffix"
                        @input="coupon.Suffix=$event.target.value.toUpperCase()"
                      />                    
                    </div>
                  </div>
                   <div class="col-md-3">
                    <div class="form-group">
                      <label>Total Generate Quantity </label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Quantity"
                        v-model="coupon.Quantity"
                        min="1"
                        step="1"
                      />
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label> Expire In Days </label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="ExpireInDays"
                        v-model="coupon.ExpireInDays"
                        min="1"
                        step="1"
                      />
                    </div>
                  </div>
                  
            </div>
                <div class="row">
                  <div class="col-md-6  center well" >{{coupon.Prefix ? coupon.Prefix+'-':''}}{{sampleCoupon}}{{coupon.Suffix ? '-'+coupon.Suffix:''}} </div>
                <div class="col-md-6 center">
                        
                          <button
                            class="btn-raised btn-primary btn fixcolorAs "
                            :disabled="loading"
                          >
                            <span
                              v-show="loading"
                              class="spinner-border spinner-border-sm"
                            ></span>
                            <span>Generate Coupon</span>
                          </button>
                  
                  </div>
                </div>
                
          </form>
          <div class="row">
             <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
              />
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>
         
          <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Prefix Coupon Code</th>
                    <th>Suffix Coupon Code</th>
                    <th>Coupon Batch Expiery Days</th>
                    <th>Total Generated Quantity</th>
                    <th>Generated By</th>
                    <th>Updation Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in coupon_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td class="left-align">
                      {{ item.PrefixCouponCode }}
                    </td>
                    <td>{{ item.SuffixCouponCode }}</td>
                    <td>{{ item.CouponBatchExpieryDays }}</td>
                    <td>{{ item.TotalGeneratedQuantity}}</td>
                    <td>{{ item.first_name }} {{ item.last_name }}</td>
                    <td>{{ item.created_date | dateFormatReadable}}</td>
                    
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
        </div>
         </div>
      </div>
    </div>
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment'
import UserService from '../../services/user.service';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import ModelSelectEnquery from '../components/ModelSelectEnquery'
import VeeValidate from 'vee-validate';


function initialState() {
  return {
        Suffix: '',
        Prefix: '',
        Quantity: '1',
        ExpireInDays:'30'
      }
}
export default {
  name: 'generateCoupons',
  data() {
    return {
      coupon_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      loading:false,
      isReadOnly:true,
      message: '',
      SuccessMessage:'',
      sampleCoupon:'COUPON' ,
      coupon: initialState(),
    };
  },
  components: { vSelect,ModelSelectEnquery,Paginate},
  computed: {
  },
  created(){
    this.getAllCoupons(1);
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
     getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Coupon/GeneratedList', params)
        .then((response) => {
          const {
            coupon_data,
            totalItems,
            currentPage,
            TotalPage,
                      
          } = response.data;
          this.coupon_data = coupon_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
         
         
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 2000)
    },
   upper(e) {
        e.target.value = e.target.value.toUpperCase()
    },
    submitForm() {
      this.$validator.validateAll().then((res) => {
        
        if (!res) {
          // handle input errors.
          this.message = 'Please Fill all menditory Options';
            setTimeout(() => (this.message = false), 5000);
          return;
        }
        if (res) {
          let loader = this.$loading.show();
          UserService.postMetod(
            'kspgAPI/Coupon/generate',
            this.coupon
          ).then(
            (response) => {
              this.SuccessMessage = response.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.loading = false;
              this.getAllCoupons(1);
              // on success reset values
              if (response.data.status) {
                this.resetWindow();
                /*Clear Validation */
                 this.$nextTick(() => {
                    this.errors.clear();
                    this.$nextTick(() => {
                        this.$validator.reset();
                    });
                });
              }
            },
            (error) => {
              this.loading = false;

              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
            setTimeout(() => {loader.hide()}, 1000)
        } else {
          this.message = 'Please correct all error!';
        }
      });
    },
    resetWindow: function () {
      Object.assign(this.$data.coupon, initialState());
    }
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
<style>
.visibility {
  visibility:visible !important;
}

</style>